module.exports = __webpack_public_path__ + "img/kitty-packshots-right.b6f07848.png";